var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-sider',{attrs:{"collapsed":true}},[_c('main-menu-new')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }